import React, { forwardRef } from 'react';

import type { LinkProps } from 'react-router';

import type { AdditionalLinkProps } from '@change/ds-core-ui';

import { Link } from '@change-corgi/core/react/router';

declare module '@change/ds-core-ui' {
	// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface AdditionalLinkProps extends Omit<LinkProps, 'to'> {
		forceMode?: 'internal' | 'external';
	}
}

type DSLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
	href: string;
	download?: boolean | string;
} & AdditionalLinkProps;

export const DSLink = forwardRef<HTMLAnchorElement, DSLinkProps>(({ href, download, children, ...rest }, ref) => {
	// Use native anchor for download links to allow browser's native download behavior
	if (download !== undefined) {
		return (
			// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, react/forbid-elements
			<a href={href} download={download} ref={ref} {...rest}>
				{children}
			</a>
		);
	}

	return (
		<Link to={href} ref={ref} {...rest}>
			{children}
		</Link>
	);
});

DSLink.displayName = 'DSLink';
